export const addQueryString = (facetsName, value) => {

  const params = new URLSearchParams(window.location.search);
  params.set(facetsName, value);

  window.history.replaceState({}, '', `${window.location.pathname}?${params}`);

};

export const removeQueryString = (facetsName) => {
  const params = new URLSearchParams(window.location.search);
  if(params.toString().length && params.toString().indexOf(facetsName) !== -1){
    params.delete(facetsName);
    window.history.replaceState({}, '', `${window.location.pathname}?${params}`);
  }
};
export function qsToObject(qs) {
  if (!qs) {
    return {};
  }
  const hashes = qs.slice(qs.indexOf('?') + 1).split('&');
  const params = {};
  hashes.map((hash) => {
    const param = hash.split('=');
    const key = param.shift();
    const val = param.join('=');
    params[key] = decodeURIComponent(val);
  });
  return params;
}
export const isRTL = document.body.getAttribute('data-language') === 'ar';
export const masonryOptions = {
  transitionDuration: 0,
  originLeft: !isRTL
};

export const defaultMapState = {
  lat: 25.2048493,
  lng: 55.2707828,
  activeMarker: 0,
  markers: [{
    lat: 25.2048493,
    lng: 55.2707828, title: 'asdas'
  }, {
    lat: 25.0906126,
    lng: 55.1955616, title: 'asdas'
  }],
};

export const googleMapDirectionLink = (lat, lng) => {
  return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
};